import * as React from 'react';
import { Col, Container, Row } from 'reactstrap';
import Button from 'reactstrap/lib/Button';
import { TR } from 'src/TextRes';
import {
    ApiAccountingCloseMonth,
    ApiDashboardLoad,
    DashboardBookingListEntry,
    DashboardCourseListEntry,
    DashboardCourseProviderListEntry,
    DashboardResult,
    ServerResponse,
} from '../../api';
import FieldsetBoxWithCollapseButton from '../../components/fieldsetBoxWithCollapseButton/FieldsetBoxWithCollapseButton';
import Footer from '../../components/footer/Footer';
import HeaderLoggedIn from '../../components/headerLoggedIn/HeaderLoggedIn';
import NetworkOverlay from '../../components/networkOverlay/NetworkOverlay';
import { IEmptyProps } from '../../constants';
import './AdminDashboard.css';

interface IState {
    dashboardResult?: DashboardResult;
    loading: boolean;
    serverResponse: ServerResponse | undefined;
}

export default class AdminDashboard extends React.PureComponent<IEmptyProps, IState> {
    constructor(props: IEmptyProps) {
        super(props);
        this.state = {
            dashboardResult: undefined,
            loading: true,
            serverResponse: undefined,
        };
    }

    public componentDidMount() {
        ApiDashboardLoad((sr) => {
            if (sr.OK) {
                this.setState({
                    dashboardResult: sr.Data,
                    loading: false,
                    serverResponse: sr,
                });
            } else {
                console.log(sr.Error);
            }
        });
    }

    public render() {
        return (
            <NetworkOverlay loading={this.state.loading} serverResponse={this.state.serverResponse}>
                <HeaderLoggedIn />
                {this.state.dashboardResult && (
                    <Container className="dashboard">
                        <Row>
                            <Col md={12}>
                                <Button
                                    className={'mb-5'}
                                    onClick={() => {
                                        ApiAccountingCloseMonth((sr) => {
                                            if (sr.OK) {
                                                console.log('geklappt');
                                            } else {
                                                console.log('nicht geklappt');
                                            }
                                        });
                                    }}
                                >
                                    Vormonat abschließen
                                </Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <FieldsetBoxWithCollapseButton
                                    legendTitel={TR.adminDashboard_newest_bookings}
                                    renderTBodyLine={this.renderTBodyBookingsLine}
                                    listData={this.state.dashboardResult.Bookings}
                                    firstNumber={5}
                                    fieldsetClass="form-group"
                                    tableClass="form-group"
                                />
                            </Col>
                            <Col md={12}>
                                <FieldsetBoxWithCollapseButton
                                    legendTitel={TR.adminDashboard_newest_registrations}
                                    renderTBodyLine={this.renderTBodyCourseProviderLine}
                                    listData={this.state.dashboardResult.CourseProviders}
                                    firstNumber={5}
                                    fieldsetClass="form-group"
                                    tableClass="form-group"
                                />
                            </Col>
                            <Col md={12}>
                                <FieldsetBoxWithCollapseButton
                                    legendTitel={TR.adminDashboard_newest_courses}
                                    renderTBodyLine={this.renderTBodyCourseLine}
                                    listData={this.state.dashboardResult.Courses}
                                    firstNumber={5}
                                    fieldsetClass="form-group"
                                    tableClass="form-group"
                                />
                            </Col>
                        </Row>
                    </Container>
                )}
                <Footer />
            </NetworkOverlay>
        );
    }

    private renderTBodyCourseLine = (value: DashboardCourseListEntry, i: number) => {
        return (
            <tr key={i}>
                <td>{value.DaysAgo}</td>
                <td>{value.CourseProviderName}</td>
                <td>{value.Title}</td>
            </tr>
        );
    };

    private renderTBodyBookingsLine = (value: DashboardBookingListEntry, i: number) => {
        return (
            <tr key={i}>
                <td>{value.DaysAgo}</td>
                <td>{value.Course}</td>
                <td>{value.CourseProvider}</td>
                <td>{value.Name}</td>
                <td>{value.Fee}</td>
            </tr>
        );
    };

    private renderTBodyCourseProviderLine = (value: DashboardCourseProviderListEntry, i: number) => {
        return (
            <tr key={i}>
                <td>{value.DaysAgo}</td>
                <td>{value.Name}</td>
            </tr>
        );
    };
}



// WEBPACK FOOTER //
// ./src/views/adminDashboard/AdminDashboard.tsx